import { render, staticRenderFns } from "./WholeMultiselect.html?vue&type=template&id=60674fa0&external"
import script from "./WholeMultiselect.vue?vue&type=script&lang=js"
export * from "./WholeMultiselect.vue?vue&type=script&lang=js"
import style0 from "./WholeMultiselect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports